/* eslint-disable max-len */
import { PrimaryButton, TertiaryButton } from '@components/library/button';
import { StandardDialog } from '@components/library/dialog';
import { FontIcon, FontIconColors, FontIcons } from '@components/library/icon';
import React, { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { BrandfoldersResponseObject } from './InsightsTypes';

export interface ConnectSuccessDialogProps {
  brandfoldersData: BrandfoldersResponseObject[];
  handleViewBrandfoldersToSync: () => void;
  isConnectionSuccessDialogOpen: boolean;
  setIsConnectionSuccessDialogOpen: Dispatch<SetStateAction<boolean>>;
}

export const ConnectSuccessDialog: FunctionComponent<ConnectSuccessDialogProps> = (
  { brandfoldersData,
    handleViewBrandfoldersToSync,
    isConnectionSuccessDialogOpen,
    setIsConnectionSuccessDialogOpen
  }) => {
  const brandfolderSlug = brandfoldersData?.[0]?.attributes.slug;
  let insightsDataLink: string;

  if (brandfolderSlug) {
    insightsDataLink = `https://brandfolder.com/insights/?page=/insights-app/${brandfolderSlug}/insights`;
  } else {
    insightsDataLink = 'https://brandfolder.com/insights/?page=/insights-app/';
  }
  
  return (
    <StandardDialog
      dialogBodyClassName="connect-smartsheet-success-dialog-body"
      dialogHeaderClassName="connect-smartsheet-success-dialog-header"
      height={523}
      id="smartsheet-connect-success-dialog"
      onClose={(): void => {
        handleViewBrandfoldersToSync();
      }}
      open={isConnectionSuccessDialogOpen}
      setOpen={setIsConnectionSuccessDialogOpen}
      showFooter={false}
      showTitle={false}
      title=""
      width={965}
    >
      <div className="connect-smartsheet-success-dialog__body">
        <FontIcon aria-hidden color={FontIconColors.Text} icon={FontIcons.CheckMarkCircle} iconSize={35}></FontIcon>
        <p className="connect-smartsheet-success-dialog__title">{bfTranslate('You are successfully connected to Smartsheet.')}</p>
        <span className="connect-smartsheet-success-dialog__note">
          <p className="connect-smartsheet-success-dialog__note-text">{bfTranslate('Note: If you edit or remove content from your synced sheet, the data may not sync. Get some tips on how to effectively use the data in your sheet ')}</p>
          <a className="connect-smartsheet-success-dialog-link" href="https://help.brandfolder.com/hc/en-us/articles/4421309127831" target="_blank">{bfTranslate('here')}</a>
        </span>
        <div className="connect-smartsheet-success-dialog__buttons">
          <TertiaryButton
            className="connect-smartsheet-success-dialog__view-insights"
            onClick={(): void => {
              window.open(
                insightsDataLink,
                '_blank'
              );
              setIsConnectionSuccessDialogOpen(false);
            }}
          >
            {bfTranslate('View Insights Data')}
          </TertiaryButton>
          <PrimaryButton
            className="connect-smartsheet-success-dialog__select"
            onClick={(): void => {
              handleViewBrandfoldersToSync();
            }}
          >
            {bfTranslate('View Brandfolders to Sync')}
          </PrimaryButton>
        </div>
      </div>
    </StandardDialog>
  );
};